import React from 'react';

import style from './index.less';

const EventBox = props => {
  const { children, hasStreamBottom } = props;
  return (
    <div className={`${style['event-wrapper']} ${hasStreamBottom ? style['last-stream'] : ''}  event-wrapper`}>
      {children}
    </div>
  );
};

export default EventBox;
